import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPencilFill = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.5967 6.55371C14.1338 6.67218 15.7468 7.10204 16.8682 8.19922C17.9738 9.27991 18.4132 10.8232 18.5391 11.3643C17.7166 12.265 16.7113 13.3185 15.4932 14.5283C10.4415 19.5442 8.4222 20.8607 8.33887 20.9141C8.22311 20.9882 8.09052 21.0321 7.95313 21.043L4.53516 21.3066C4.51374 21.3091 4.49228 21.3086 4.47168 21.3086C4.25085 21.3086 4.03753 21.2211 3.88086 21.0645C3.70851 20.892 3.62132 20.6534 3.63965 20.4102L3.90527 17.0176C3.91615 16.8794 3.96232 16.7455 4.03809 16.6289C4.09225 16.5464 5.41723 14.5401 10.4697 9.52344C11.6613 8.34021 12.7026 7.36032 13.5967 6.55371ZM18.2979 3.10449C18.4462 3.12783 19.7761 3.36138 20.7402 4.30469C21.6991 5.27106 21.9362 6.59407 21.96 6.74414C21.9916 6.94318 21.9503 7.14759 21.8438 7.31836C21.8079 7.37669 21.2683 8.22539 19.835 9.90039C19.5166 9.0338 18.9623 7.91605 18.0342 7.00781C17.1092 6.10281 15.9675 5.56167 15.085 5.25C16.8005 3.79939 17.6701 3.25557 17.7295 3.21875C17.8986 3.11376 18.1004 3.07201 18.2979 3.10449Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgPencilFill);
export default ForwardRef;
